import React, { useState } from "react";
import axios from "axios";
import Results from "./Results.js";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary(props) {
   let [keyword, setKeyword]= useState(props.defaultKeyword);
   let [results, setResults]= useState(null);
   let [loaded, setLoaded]= useState(false);
   let [photos, setPhotos]= useState(null);

function handleDictionaryResponse(response){
setResults(response.data[0]);
}

function handlePexelsResponse(response){
    setPhotos(response.data.photos);

}

function search(){
//documentation: dictionaryapi.dev/
    let apiUrl=`https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleDictionaryResponse);

    let pexelsApiKey=
    "563492ad6f917000010000014fb1d79164144b0cbc11901374b0f0a4";
    let pexelsApiUrl=
    `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
    let headers={Authorization : `Bearer ${pexelsApiKey}`};
    
    axios.get(pexelsApiUrl, {headers:headers }).then(handlePexelsResponse);
}

   function handleSubmit(event){
    event.preventDefault();
    search();
}



function handleKeywordChange(event){
    setKeyword(event.target.value);
}
function load(){
    setLoaded(true);
    search();
}

if (loaded){
return(
<div className="Dictionary">
    <section>
        <h2>What word do you want to look up?</h2>
<form onSubmit={handleSubmit}>
    <input type="Search" onChange={handleKeywordChange} defaultValue={props.defaultKeyword} />
    </form>
    <div className="hint">
Suggested words: bridge, energy, star...
        </div>
    </section>
    <Results results={results} />
    <Photos photos={photos} />
</div>
    );
} else{
    load();
    return "Loading...";
}
}